import { Button } from "@/components/ui/button";
import { Plus, Users } from "lucide-react";

interface BookingsEmptyBannerProps {
  onCreateBooking: () => void;
}

const BookingsEmptyBanner = ({ onCreateBooking }: BookingsEmptyBannerProps) => (
  <div className="bg-gray-50 border border-gray-200 rounded-lg p-8 text-center">
    <Users className="h-12 w-12 text-gray-400 mx-auto mb-4" />

    <h3 className="text-gray-800 font-medium mb-2">No hay reservaciones</h3>

    <p className="text-gray-600 text-sm mb-4">
      No se encontraron reservaciones en la base de datos.
    </p>

    <Button onClick={onCreateBooking} className="bg-brand-primary hover:bg-brand-primary-hover">
      <Plus className="h-4 w-4 mr-2" />
      Crear Primera Reservación
    </Button>
  </div>
);

export default BookingsEmptyBanner;
